import * as serializers from '../../serializers'

export const getStoreStatuses = serializers.application

export const getStoreGroups = serializers.application

export const getStoreProducts = serializers.application

export const getNetworks = serializers.application

export const getSubsidiary = serializers.application

export const getPartners = (res) => {
  const { data = {}, headers = {}, metadata = {} } = res

  const newData = data.map((item) => ({
    id: item.stdCode,
    name: item.name
  }))

  return {
    data: newData,
    headers,
    metadata
  }
}

export const getPriorityMatrices = serializers.application
